/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ExternalBarangayDto } from '../model';
// @ts-ignore
import type { ExternalCityMunicipalityDto } from '../model';
// @ts-ignore
import type { ExternalClientControllerHealthCheck200Response } from '../model';
// @ts-ignore
import type { ExternalProvinceDto } from '../model';
/**
 * ExternalClientApi - axios parameter creator
 * @export
 */
export const ExternalClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get barangays for a specific city/municipality
         * @param {string} cityMunicipalityCode City/municipality code to get barangays for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalClientControllerGetBarangays: async (cityMunicipalityCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityMunicipalityCode' is not null or undefined
            assertParamExists('externalClientControllerGetBarangays', 'cityMunicipalityCode', cityMunicipalityCode)
            const localVarPath = `/api/external-client/cities-municipalities/{cityMunicipalityCode}/barangays`
                .replace(`{${"cityMunicipalityCode"}}`, encodeURIComponent(String(cityMunicipalityCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get cities/municipalities for a specific province
         * @param {string} provinceCode Province code to get cities/municipalities for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalClientControllerGetCitiesMunicipalities: async (provinceCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provinceCode' is not null or undefined
            assertParamExists('externalClientControllerGetCitiesMunicipalities', 'provinceCode', provinceCode)
            const localVarPath = `/api/external-client/provinces/{provinceCode}/cities-municipalities`
                .replace(`{${"provinceCode"}}`, encodeURIComponent(String(provinceCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all provinces from external geographical API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalClientControllerGetProvinces: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/external-client/provinces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check external API connectivity health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalClientControllerHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/external-client/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalClientApi - functional programming interface
 * @export
 */
export const ExternalClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get barangays for a specific city/municipality
         * @param {string} cityMunicipalityCode City/municipality code to get barangays for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalClientControllerGetBarangays(cityMunicipalityCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalBarangayDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalClientControllerGetBarangays(cityMunicipalityCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientApi.externalClientControllerGetBarangays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get cities/municipalities for a specific province
         * @param {string} provinceCode Province code to get cities/municipalities for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalClientControllerGetCitiesMunicipalities(provinceCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalCityMunicipalityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalClientControllerGetCitiesMunicipalities(provinceCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientApi.externalClientControllerGetCitiesMunicipalities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all provinces from external geographical API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalClientControllerGetProvinces(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalProvinceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalClientControllerGetProvinces(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientApi.externalClientControllerGetProvinces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check external API connectivity health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async externalClientControllerHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExternalClientControllerHealthCheck200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.externalClientControllerHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalClientApi.externalClientControllerHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalClientApi - factory interface
 * @export
 */
export const ExternalClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalClientApiFp(configuration)
    return {
        /**
         * 
         * @summary Get barangays for a specific city/municipality
         * @param {string} cityMunicipalityCode City/municipality code to get barangays for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalClientControllerGetBarangays(cityMunicipalityCode: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExternalBarangayDto>> {
            return localVarFp.externalClientControllerGetBarangays(cityMunicipalityCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get cities/municipalities for a specific province
         * @param {string} provinceCode Province code to get cities/municipalities for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalClientControllerGetCitiesMunicipalities(provinceCode: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExternalCityMunicipalityDto>> {
            return localVarFp.externalClientControllerGetCitiesMunicipalities(provinceCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all provinces from external geographical API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalClientControllerGetProvinces(options?: RawAxiosRequestConfig): AxiosPromise<Array<ExternalProvinceDto>> {
            return localVarFp.externalClientControllerGetProvinces(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check external API connectivity health
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        externalClientControllerHealthCheck(options?: RawAxiosRequestConfig): AxiosPromise<ExternalClientControllerHealthCheck200Response> {
            return localVarFp.externalClientControllerHealthCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ExternalClientApi - object-oriented interface
 * @export
 * @class ExternalClientApi
 * @extends {BaseAPI}
 */
export class ExternalClientApi extends BaseAPI {
    /**
     * 
     * @summary Get barangays for a specific city/municipality
     * @param {string} cityMunicipalityCode City/municipality code to get barangays for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalClientApi
     */
    public externalClientControllerGetBarangays(cityMunicipalityCode: string, options?: RawAxiosRequestConfig) {
        return ExternalClientApiFp(this.configuration).externalClientControllerGetBarangays(cityMunicipalityCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get cities/municipalities for a specific province
     * @param {string} provinceCode Province code to get cities/municipalities for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalClientApi
     */
    public externalClientControllerGetCitiesMunicipalities(provinceCode: string, options?: RawAxiosRequestConfig) {
        return ExternalClientApiFp(this.configuration).externalClientControllerGetCitiesMunicipalities(provinceCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all provinces from external geographical API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalClientApi
     */
    public externalClientControllerGetProvinces(options?: RawAxiosRequestConfig) {
        return ExternalClientApiFp(this.configuration).externalClientControllerGetProvinces(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check external API connectivity health
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalClientApi
     */
    public externalClientControllerHealthCheck(options?: RawAxiosRequestConfig) {
        return ExternalClientApiFp(this.configuration).externalClientControllerHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }
}

